export default{
    created () {
        document.documentElement.style.setProperty('--main-thema-color', '#246AF2');
        document.documentElement.style.setProperty('--background-color', '#fff');
        document.documentElement.style.setProperty('--disable-background-color', '#F2F3F5');
        document.documentElement.style.setProperty('--hover-color', '#1A56D5');
    },
}